import React, { useEffect, useContext, useState } from 'react'
import { Box, Text } from "grommet"

import { useGetTaskLogging } from './TriageHistoryAPI'
import UserContext from '../../../../context/UserContext'

import * as moment from "moment-timezone"
import { SpinnerOverlayAthena } from '../../../common/SpinnerOverlay'


function getLogColor(loglevel) {
    if (loglevel === '30') {
        return "accent-4"
    } else if (loglevel === '40' || loglevel === '50') {
        return "status-critical"
    } else {
        return "accent-1"
    }
}


function formatLogs(timezone, eachLog) {

    // \u00a0 is for whitespace
    let loglevel = "INFO\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0"
    if (eachLog.logginglevel === '10') {
        loglevel = "DEBUG\u00a0\u00a0\u00a0\u00a0\u00a0"
    } else if (eachLog.logginglevel === '30') {
        loglevel = "WARNING"
    } else if (eachLog.logginglevel === '40') {
        loglevel = "ERROR\u00a0\u00a0\u00a0\u00a0\u00a0"
    } else if (eachLog.logginglevel === '50') {
        loglevel = "CRITICAL"
    }

    let timestamp_temp = ''
    timestamp_temp = moment(moment(eachLog.timestamp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
    timestamp_temp = moment(timestamp_temp).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')

    let logMessage = []
    eachLog.message.split('\n').forEach((line, index) => {
        if (index === 0) {
            logMessage.push(<Text size='13px' key={timestamp_temp}>{timestamp_temp + ' | ' + loglevel + ' | ' + line}</Text>)
        }
        else {
            logMessage.push(<br />)
            logMessage.push(<Text size='13px' key={timestamp_temp + line}>{line}</Text>)
        }
    })
    return logMessage
}

export const TriageHistoryViewLog = ({ content }) => {

    const token = useContext(UserContext)
    const { urlResponse: taskLogging, isLoading } = useGetTaskLogging(content.taskid)
    const [logdata, setLogdata] = useState([])

    useEffect(() => {
        if (taskLogging && taskLogging.length > 0) {
            setLogdata(taskLogging)
        }
    }, [content, taskLogging])

    // AutoScrolling Behavior
    const messagesEndRef = React.createRef()
    const scrollToBottom = ({ behavior }) => {
        messagesEndRef && messagesEndRef.current && messagesEndRef.current.scrollIntoView({ behavior: behavior })
    }

    // When Streaming in Smooth Scroll
    useEffect(() => {
        scrollToBottom("smooth")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logdata])

    // On First Load Instant Scroll
    useEffect(() => {
        scrollToBottom("instant")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (

        <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }} gap="small">
            <Text name="triageLog" weight='bold'>Triage Log</Text>

            {isLoading &&
                <SpinnerOverlayAthena />
            }


            <Box
                overflow={{ horizontal: 'hidden', vertical: 'auto' }}
                direction="column"
                margin={{ top: "40px" }}
                pad={{ top: '15px', left: '20px', right: '20px', bottom: '15px' }}
                background="black"
            >
                {!isLoading &&

                    <>
                        {
                            logdata.length === 0 &&
                            <Text margin={{ bottom: "4px" }} size='13px' color="accent-1">
                                No Logs To Display
                            </Text>
                        }
                        {logdata.length > 0 &&
                            logdata.map(eachLog => (

                                <Text wordBreak={true} margin={{ bottom: "4px" }} key={eachLog.timestamp + '_ts'} size='13px' color={getLogColor(eachLog.logginglevel)}>
                                    {formatLogs(token.timezone, eachLog)}
                                </Text>

                            ))
                        }
                        <Box ref={messagesEndRef}></Box>
                    </>

                }
            </Box>


        </Box>
    )
}

export default TriageHistoryViewLog